const rutasSprites = [
  /*{
    name: "textura_ejemplo",
    type: "texture",
    path: "texturas/sprites/ejemplo.png",
  },*/
  
];

export default rutasSprites;
